import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './navigation.css'
import logoStatic from '../assets/logoStatic.png';
import logoAnimated from '../assets/logoAnimated.gif';

const Navigation = () => {
    const { user, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        console.log('User in Navigation:', user);
    }, [user]);

    const handleMouseEnter = () => {
        setIsHovered(true);
        setTimeout(() => {
            setIsHovered(false);
        }, 2000);
    };

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <nav className="navbar">
            <div className="nav-left">
                <img
                    src={isHovered ? logoAnimated : logoStatic}
                    alt="FitSaverAI Logo"
                    className="nav-logo-img"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={() => setIsHovered(false)}
                />
                {user ? (
                    <>
                        <Link to="/dashboard" className="nav-logo">
                            <span className="fit">Fit</span><span className="saveai">SaveAI</span><span className="dot-org">.org</span>
                        </Link>
                        <Link to="/dashboard" className="nav-link">Dashboard</Link>
                        <Link to="/oasis" className="nav-link">Oasis</Link>
                    </>
                ) : (
                    <Link to="/" className="nav-logo">
                        <span className="fit">Fit</span><span className="saveai">SaveAI</span><span className="dot-org">.org</span>
                    </Link>
                )}
            </div>
            <div className="nav-right">
                {user ? (
                    <>
                        <div className="dropdown">
                            <button className="btn btn-tertiary">{user.name || 'User'}</button>
                            <div className="dropdown-content">
                                <Link to='/profile'>Profile</Link>
                                <Link to='/accInfo'>Account Info</Link>
                                <a href="#" className='last' onClick={handleLogout}>Log Out</a>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <Link to="/login" className="btn btn-secondary">Sign In</Link>
                        <Link to="/register" className="btn btn-primary">Register</Link>
                    </>
                )}
            </div>
        </nav>
    );
};

export default Navigation;